// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__270Gb","col":"Table_col__34QB8","fulfillmentStatus":"Table_fulfillmentStatus__3_eAN","emailCol":"Table_emailCol__6Gs8r"};